import { useState } from 'react';
import { useHistory, useLocation } from 'react-router';

/*
 * For use with /components/shared/Paginate.jsx
 */
function usePagination({ pagination, options, urlParam = 'page', updateUrl = true }) {
  const history = useHistory();
  const location = useLocation();

  const [currentPage, setCurrentPage] = useState(pagination ? pagination.page : 1);

  const onPageChange = (pageInfo) => {
    const newPage = pageInfo.selected + 1;
    if (newPage === pagination.page) return;

    const searchParams = new URLSearchParams(location.search);
    searchParams.set(urlParam, newPage);

    setCurrentPage(newPage);

    if (updateUrl) {
      history.push({
        pathname: location.pathname,
        search: searchParams.toString()
      });
    }
  };

  const paginationProps = pagination && pagination.total_pages > 1 ? {
    ...options,
    pageCount: pagination.total_pages,
    onPageChange,
    forcePage: pagination.page - 1,
    pageRangeDisplayed: 2,
    marginPagesDisplayed: 1
  } : null;

  return {
    paginationProps,
    currentPage,
    showPagination: pagination && pagination.total_pages > 1,
    setCurrentPage
  };
}

export default usePagination;
